import { createSharedPhaserConfig } from '../../shared/phaser/sharedPhaserConfig';
import { RANGER_LEVELS } from './data/levels/level-01';
import { createBootScene } from './scenes/BootScene';
import { createMissionScene } from './scenes/MissionScene';
import { createPreloadScene } from './scenes/PreloadScene';

export function createRangerGameConfig({
  Phaser,
  controllerInputRef,
  events = {},
  initialLives,
  levelIndex = 0,
  onGameOver,
  onLivesChange,
  onMissionComplete,
  reducedMotion = false,
  selectedPlayableIcon = 'ranger',
}) {
  const level = RANGER_LEVELS[levelIndex] ?? RANGER_LEVELS[0];
  const missionEvents = {
    onGameOver: events.onGameOver ?? onGameOver,
    onLivesChange: events.onLivesChange ?? onLivesChange,
    onMissionComplete: events.onMissionComplete ?? onMissionComplete,
  };

  return createSharedPhaserConfig({
    type: Phaser.AUTO,
    physics: {
      default: 'arcade',
      arcade: {
        debug: false,
      },
    },
    scene: [
      createBootScene({ level, selectedPlayableIcon }),
      createPreloadScene({ level, selectedPlayableIcon }),
      createMissionScene({
        controllerInputRef,
        initialLives,
        level,
        levelIndex,
        onGameOver: missionEvents.onGameOver,
        onLivesChange: missionEvents.onLivesChange,
        onMissionComplete: missionEvents.onMissionComplete,
        reducedMotion,
        selectedPlayableIcon,
      }),
    ],
  });
}
